import React from "react";
import PropTypes from "prop-types";
import { Bling as GPT } from "react-gpt";

import ErrorBoundary from "components/Library/ErrorBoundary";

export default function Ad({ adUnit, ...props }) {
  return (
    <ErrorBoundary>
      <GPT
        adUnitPath={`/227892952/axios/${adUnit}`}
        {...props}
      />
    </ErrorBoundary>
  );
}

Ad.propTypes = {
  adUnit: PropTypes.string.isRequired,
};
